import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import classnames from 'classnames';
import { PlusCircleOutlined } from '@ant-design/icons';

import { Row, Button, Col } from 'antd';
import ColumnDraggable from './ColumnDraggable';
import useGetProperties from '../hook/useGetProperties';
import { UPDATE_COLUMNS } from '../utils/constants';
import { CustomNotification } from 'common/components';

import './DataColumns.less';
import EmptyAttribute from './EmptyAttribute';

const DataColumns = (props) => {
  const {
    propertiesData,
    entityType,
    viewMode,
    dataColumns,
    handleUpdateDataColumns,
  } = props;

  const { getPropertyData, selectTreeData } = useGetProperties({
    propertiesData,
    entityType,
  });

  const handleAddColumns = () => {
    if (dataColumns.includes(undefined)) {
      CustomNotification.warning(
        'Please select column before adding new column'
      );
    } else
      handleUpdateDataColumns({
        type: UPDATE_COLUMNS.ADD,
      });
  };

  return (
    <Droppable droppableId={'data_columns'} isCombineEnabled={true}>
      {(provided, { isDraggingOver }) => {
        return (
          <div
            ref={provided.innerRef}
            className={classnames({
              'data-columns': true,
              'data-columns scroller-extend': true,
            })}
          >
            {dataColumns?.length > 0 ? (
              <div style={{ pointerEvents: viewMode ? 'none' : 'auto' }}>
                {dataColumns?.map((fieldName, index) => {
                  const property = getPropertyData(fieldName);
                  const key = !!fieldName ? fieldName : index;
                  return (
                    <ColumnDraggable
                      key={key + '_columns'}
                      index={index}
                      viewMode={viewMode}
                      property={property}
                      dataColumns={dataColumns}
                      selectTreeData={selectTreeData}
                      handleUpdateDataColumns={handleUpdateDataColumns}
                    />
                  );
                })}
                {!viewMode && !isDraggingOver && (
                  <Row>
                    <Col span={24}>
                      <Button
                        ghost
                        type='primary'
                        shape='round'
                        onClick={handleAddColumns}
                        size='small'
                        icon={<PlusCircleOutlined />}
                      >
                        Add Column
                      </Button>
                    </Col>
                  </Row>
                )}
              </div>
            ) : (
              <>
                {!viewMode && (
                  <EmptyAttribute
                    text='Data Columns'
                    onClick={handleAddColumns}
                  />
                )}
              </>
            )}
            {provided.placeholder}
          </div>
        );
      }}
    </Droppable>
  );
};

export default React.memo(DataColumns);
